import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import moment from "moment";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import { Divider, Stack, Badge } from "@mui/material";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import dayjs from "dayjs";
import {
  CloudOffIcon,
  SearchIcon,
  DeleteIcon,
  EditIcon,
  DownloadIcon,
  RemoveRedEyeIcon,
  AddIcon,
} from "../../../Resources/Icons/icons";
import {
  GetPaidReceivedReport,
  GetUser,
  DeletePolicyReportData,
  ReframeEndDateTimeFormat,
  PaidWallet,
} from "../../../Service/_index";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { DatePicker } from "antd";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import EditPaidAndReceived from "./EditPaidAndReceived";
import PaidTransaction from "../../UserWallet/PaidTransaction";
import { CSVLink } from "react-csv";

import TabFilter from "../../Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import { isAction } from "@reduxjs/toolkit";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterListIcon from "@mui/icons-material/FilterList";

const { RangePicker } = DatePicker;
const TodayDate = new Date();
// TodayDate .setHours(23, 0, 0, 0);
const Last7Days = new Date();
Last7Days.setDate(Last7Days.getDate() - 7);
const YesterDay = new Date();
YesterDay.setDate(YesterDay.getDate() - 1);
const Last30Days = new Date();
Last30Days.setDate(Last30Days.getDate() - 30);

const TodayDateByDaysjs = dayjs();
const FirstDateOfMonth = TodayDateByDaysjs.startOf("month");
const FirstDateOfLastMonth = TodayDateByDaysjs.subtract(1, "month").startOf(
  "month",
);
const LastDateOfLastMonth = TodayDateByDaysjs.subtract(1, "month").endOf(
  "month",
);

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "transactionDate",
    placeMent: true,
    disablePadding: false,
    label: "Transaction Date",
  },
  {
    id: "paymentDate",
    placeMent: true,
    disablePadding: false,
    label: "Payment Date",
  },
  {
    id: "userName",
    placeMent: true,
    disablePadding: false,
    label: "User Name",
  },
  {
    id: "bankAccountHolderName",
    placeMent: true,
    disablePadding: false,
    label: "Account Holder Name",
  },
  {
    id: "amount",
    placeMent: true,
    disablePadding: false,
    label: "Amount",
  },
  {
    id: "TDSamount",
    placeMent: true,
    disablePadding: false,
    label: "TDS Amount",
  },
  {
    id: "paymentType",
    placeMent: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  {
    id: "remark",
    placeMent: true,
    disablePadding: false,
    label: "Remark",
  },
  {
    id: "payment",
    placeMent: true,
    disablePadding: false,
    label: "Payment",
  },
];

const TdsOption = [
  { label: "All", value: "all" },
  { label: "With TDS", value: "yes" },
  { label: "Without TDS", value: "no" },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const PaymentPaidAndReceived = () => {
  const lastWeekDate = dayjs().subtract(7, "days").startOf("day");
  const todayDate = dayjs().startOf("day");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openPaidTransaction, setOpenPaidTransaction] = React.useState(false);
  const [report, setReport] = React.useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const [selectedTds, setSelectedTds] = useState(null);
  const [isPaid, setIsPaid] = useState(true);
  //   Changes by Arun
  const [functionType, setFunctionType] = useState("Paid");
  const [isViewPaidTransaction, setIsViewPaidTransaction] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(lastWeekDate);
  const [selectedEndDate, setSelectedEndDate] = useState(todayDate);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isEdit: true,
    isDelete: true,
  });
  const [searchText, setSearchText] = useState("");
  const [originalReport, setOriginalReport] = React.useState([]);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [button, setButton] = useState("");
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const formRef = React.useRef();
  const csvLinkRef = useRef();

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(report), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, filter, report],
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Changes by Arun
  // const GetTableData = (requestType) => {
  //   let reqBody = {
  //     selectedUserId: selectedUser,
  //     tdsType: selectedTds,
  //     selectedStartDate: selectedStartDate,
  //     selectedEndDate: selectedEndDate,
  //   };
  //   GetPaidReceivedReport(requestType, reqBody).then((res) => {
  //     setReport(res.data);
  //   });
  // };

  const PaidFunction = async () => {
    setIsPaid(true);
    setFunctionType("Paid");
    const requestType = "PAID";
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }
    let reqBody = {
      selectedUserId: selectedUser,
      tdsType: selectedTds,
      selectedStartDate: selectedStartDate,
      selectedEndDate: selectedEndDate,
    };
    setLoading(true);
    GetPaidReceivedReport(requestType, reqBody)
      .then((res) => {
        console.log("res", res);
        const data = res.data.map((e) => {
          return {
            ...e,
            bankAccountHolderName: e.accountNumber
              ? e?.bankDetails?.find(
                (ele) => ele.accountNumber == e.accountNumber,
              )?.bankAccountHolderName || e?.bankAccountHolderName
              : "",
            TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
            PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
          };
        });
        setReport(data);
        setOriginalReport(data);
        setPage(0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const ReceivedFunction = async () => {
    setIsPaid(false);
    setFunctionType("Received");
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }
    const requestType = "RECEIVED";
    let reqBody = {
      selectedUserId: selectedUser,
      tdsType: selectedTds,
      selectedStartDate: selectedStartDate,
      selectedEndDate: selectedEndDate,
    };
    setLoading(true);
    GetPaidReceivedReport(requestType, reqBody)
      .then((res) => {
        const data = res.data.map((e) => {
          return {
            ...e,
            bankAccountHolderName: e.accountNumber
              ? e?.bankDetails?.find(
                (ele) => ele.accountNumber == e.accountNumber,
              )?.bankAccountHolderName || e?.bankAccountHolderName
              : "",
            TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
            PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
          };
        });
        setReport(data);
        setOriginalReport(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const GetUnfilteredData = async () => {
    const requestType = isPaid ? "PAID" : "RECEIVED";
    let reqBody = {
      selectedUserId: null,
      tdsType: null,
      selectedStartDate: null,
      selectedEndDate: null,
    };
    setLoading(true);
    GetPaidReceivedReport(requestType, reqBody)
      .then((res) => {
        const data = res.data.map((e) => {
          return {
            ...e,
            bankAccountHolderName: e.accountNumber
              ? e?.bankDetails?.find(
                (ele) => ele.accountNumber == e.accountNumber,
              )?.bankAccountHolderName || e?.bankAccountHolderName
              : "",
            TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
            PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
          };
        });
        setReport(data);
        setOriginalReport(data);
        setPage(0);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setReport([]);
        setOriginalReport([]);
        setLoading(false);
      });
  };

  // const HandleCustomDays = (startDate, endDate) => {
  //   setSelectedStartDate(dayjs(startDate.setHours(1, 0, 0, 0)));
  //   setSelectedEndDate(dayjs(endDate.setHours(23, 59, 59, 59)));
  //   setIsDatePickerOpen(false);
  // };

  const onSearch = (value) => {
    console.log("Search Input:", value);

    const filteredData = report.filter((el) =>
      `${el.userName},${el.bankAccountHolderName},${el.branch},${el.amount},${el?.bankDetails?.[0]?.bankName},${el.remark},${el.payment}`
        .toLowerCase()
        .includes(value.toLowerCase()),
    );

    setReport(value ? filteredData : originalReport);
    setPage(0);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      const FilteredData = res.data
        .map((e) => {
          if (e.isEnabled && e?.userType?.includes("user")) {
            return {
              ...e,
              label: e.name + " - " + e.mobileNumber + " - " + e.email,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setUserDetails(FilteredData);
    });
  };
  React.useEffect(() => {
    GetUserDetails();
    PaidFunction();
  }, []);

  const [openConfirmBox, setOpenConfirmBox] = useState(false);

  const createPaidData = () => {
    if (!selectedUserName) {
      ToastError("Please select user");
      return true;
    }
    setIsPaid(true);
    setFunctionType("Paid");
    setOpenPaidTransaction(true);
    setIsViewPaidTransaction(false);
    setSelectedData({ userId: selectedUser });
  };

  const createReceivedData = () => {
    if (!selectedUserName) {
      ToastError("Please select user");
      return true;
    }
    setIsPaid(false);
    setFunctionType("Received");
    setOpenPaidTransaction(true);
    setIsViewPaidTransaction(false);
    setSelectedData({ userId: selectedUser });
  };

  const EditReportData = (row) => {
    setOpenPaidTransaction(true);
    setSelectedData(row);
  };

  const DeleteReportData = (row) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    // console.log("isPAid ", isPaid);
    // return true;
    DeletePolicyReportData(selectedData._id);
    // GetTableData("PAID");
    setOpenConfirmBox(false);
    isPaid ? PaidFunction() : ReceivedFunction();
    // PaidFunction();
  };

  const FilterOption = [
    {
      label: "Paid",
      isEnabled: "all",
      value: 1,
    },
    {
      label: "Received",
      isEnabled: "true",
      value: 2,
    },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    console.log("selectedOption", newValue);
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue,
    );
    console.log("selectedOption", selectedOption);
    if (newValue == 1) {
      PaidFunction();
    } else if (newValue == 2) {
      ReceivedFunction();
    }
  };

  const finalReport = report.map((item) => ({
    ...item,
    bank: item?.bankDetails[0]?.bankName,
    transactionDate: dayjs(item?.transactionDate).format("DD/MM/YYYY"),
    paymentDate: dayjs(item?.paymentDate).format("DD/MM/YYYY hh:mm A"),
  }));

  const header = [
    { label: "Transaction Date", key: "transactionDate" },
    { label: "Payment Date", key: "paymentDate" },
    { label: "User Name", key: "userName" },
    { label: "Account Holder Name", key: "bankAccountHolderName" },
    // { label: "Branch", key: "branch" },
    { label: "Amount", key: "amount" },
    { label: "TDS Amount", key: "TDSamount" },
    { label: "Payment Mode", key: "paymentType" },
    { label: "Remark", key: "remark" },
    { label: "Payment", key: "payment" },
  ];

  const csvFile = {
    filename: "Payment Paid and Received Data",
    headers: header,
    data: finalReport,
  };

  const filterButton = [
    { label: "Paid", value: "Paid", backgroundColor: "#008CBA" },
    { label: "Received", value: "Received", backgroundColor: "#008CBA" },
  ];
  const TdsOption = [
    { label: "All", value: "all", _id: "all" },
    { label: "With TDS", value: "yes", _id: "yes" },
    { label: "Without TDS", value: "no", _id: "no" },
  ];
  const filterBoxData = [
    {
      id: 1,
      label: "Select User",
      data: userDetails,
      setState: (value) => {
        setSelectedUser(value);
        const user = userDetails.find((u) => u._id === value);
        setSelectedUserName(user?.name || null);
      },
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select TDS Type",
      data: TdsOption,
      setState: setSelectedTds,
      value: selectedTds,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Date Range",
      setDate: (e) => {
        const newStartDate = e ? e[0] : null;
        const newEndDate = e ? e[1] : null;

        setSelectedStartDate(newStartDate);
        setSelectedEndDate(newEndDate);

        const requestType = isPaid ? "PAID" : "RECEIVED";
        const reqBody = {
          selectedUserId: selectedUser,
          tdsType: selectedTds,
          selectedStartDate: newStartDate,
          selectedEndDate: newEndDate,
        };

        setLoading(true);
        GetPaidReceivedReport(requestType, reqBody)
          .then((res) => {
            const data = res.data.map((e) => {
              return {
                ...e,
                bankAccountHolderName: e.accountNumber
                  ? e?.bankDetails?.find(
                    (ele) => ele.accountNumber == e.accountNumber,
                  )?.bankAccountHolderName || e?.bankAccountHolderName
                  : "",
                TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
                PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
              };
            });
            setReport(data);
            setOriginalReport(data);
            setPage(0);
            setLoading(false);
          })
          .catch(() => setLoading(false));
      },
      type: "noDefaultDate",
      defaultValue: [selectedStartDate, selectedEndDate],
    },
  ];

  // useEffect(() => {
  //   const handleDateChange = (dateRange) => {
  //     if (dateRange && Array.isArray(dateRange)) {
  //       setSelectedStartDate(dateRange ? dateRange[0].$d : null);
  //       setSelectedEndDate(dateRange ? dateRange[1].$d : null);
  //     } else {
  //       setSelectedStartDate(null);
  //       setSelectedEndDate(null);
  //     }
  //   };
  //   handleDateChange(dateRange);
  // }, [dateRange]);

  const handleClearAllState = () => {
    setSelectedUser(null);
    setDateRange(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setSelectedTds(null);
    GetUnfilteredData();
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedUser(null);
      // Call API with user filter cleared
      const requestType = isPaid ? "PAID" : "RECEIVED";
      let reqBody = {
        selectedUserId: null,
        tdsType: selectedTds,
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate,
      };
      setLoading(true);
      GetPaidReceivedReport(requestType, reqBody)
        .then((res) => {
          const data = res.data.map((e) => {
            return {
              ...e,
              bankAccountHolderName: e.accountNumber
                ? e?.bankDetails?.find(
                  (ele) => ele.accountNumber == e.accountNumber,
                )?.bankAccountHolderName || e?.bankAccountHolderName
                : "",
              TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
              PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
            };
          });
          setReport(data);
          setOriginalReport(data);
          setPage(0);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setReport([]);
          setOriginalReport([]);
          setLoading(false);
        });
    } else if (filterId === 2) {
      setSelectedTds(null);
      // Call API with TDS filter cleared
      const requestType = isPaid ? "PAID" : "RECEIVED";
      let reqBody = {
        selectedUserId: selectedUser,
        tdsType: null,
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate,
      };
      setLoading(true);
      GetPaidReceivedReport(requestType, reqBody)
        .then((res) => {
          const data = res.data.map((e) => {
            return {
              ...e,
              bankAccountHolderName: e.accountNumber
                ? e?.bankDetails?.find(
                  (ele) => ele.accountNumber == e.accountNumber,
                )?.bankAccountHolderName || e?.bankAccountHolderName
                : "",
              TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
              PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
            };
          });
          setReport(data);
          setOriginalReport(data);
          setPage(0);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setReport([]);
          setOriginalReport([]);
          setLoading(false);
        });
    } else if (filterId === 3) {
      setDateRange(null);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      // Call API with date filter cleared
      const requestType = isPaid ? "PAID" : "RECEIVED";
      let reqBody = {
        selectedUserId: selectedUser,
        tdsType: selectedTds,
        selectedStartDate: null,
        selectedEndDate: null,
      };
      setLoading(true);
      GetPaidReceivedReport(requestType, reqBody)
        .then((res) => {
          const data = res.data.map((e) => {
            return {
              ...e,
              bankAccountHolderName: e.accountNumber
                ? e?.bankDetails?.find(
                  (ele) => ele.accountNumber == e.accountNumber,
                )?.bankAccountHolderName || e?.bankAccountHolderName
                : "",
              TransactionData: moment(e.transactionDate).format("DD/MM/YYYY"),
              PaymentDate: moment(e.paymentDate).format("DD/MM/YYYY"),
            };
          });
          setReport(data);
          setOriginalReport(data);
          setPage(0);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setReport([]);
          setOriginalReport([]);
          setLoading(false);
        });
    }
  };

  const handleSaveAllFilter = () => {
    if (isPaid) {
      PaidFunction();
    } else {
      ReceivedFunction();
    }
  };

  const getRandomNumberUsingTimestamp = () => {
    const timestamp = new Date().getTime();
    return timestamp;
  };

  const handleSubmit = async (e) => {
    const UserId = sessionStorage.getItem("UserId");
    e.isUserPayable = true;
    const RandomNumber = await getRandomNumberUsingTimestamp();
    e.userId = selectedData.userId;
    e.policyNumber = RandomNumber.toString();
    e.paymentMode = (isPaid ? "Paid" : "Received")?.toUpperCase();
    e.createdBy = UserId;
    e.withTDS = value == 0 ? true : false;
    PaidWallet(e)
      .then((res) => {
        isPaid ? PaidFunction() : ReceivedFunction();
        setOpenPaidTransaction(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const activeFiltersCount =
    [selectedUser, selectedTds].filter(Boolean).length +
    (selectedStartDate && selectedEndDate ? 1 : 0);

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Table container below filter */}
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Payment Paid & Received
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        fullWidth
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                        onClick={() => csvLinkRef.current.link.click()}
                      >
                        Export
                      </Button>
                      <CSVLink
                        {...csvFile}
                        ref={csvLinkRef}
                        style={{ display: "none" }}
                      />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                    hideDefaultButtons={true}
                    customActionButtons={
                      <>
                        <Button
                          onClick={PaidFunction}
                          className="Common_Button"
                          sx={{ width: { xs: "100%", sm: "auto" } }}
                        >
                          Paid
                        </Button>
                        <Button
                          title="Create Paid"
                          className="Common_Button"
                          onClick={createPaidData}
                          endIcon={<AddIcon />}
                        ></Button>
                        <Button
                          onClick={ReceivedFunction}
                          className="Common_Button"
                          sx={{ width: { xs: "100%", sm: "auto" } }}
                        >
                          Received
                        </Button>
                        <Button
                          title="Create Received"
                          className="Common_Button"
                          onClick={createReceivedData}
                          endIcon={<AddIcon />}
                        ></Button>
                      </>
                    }
                    sx={{
                      "& .filter-box-container": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                    }}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} />
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      onSearch(e.target.value);
                    }}
                    disableUnderline={true}
                    placeholder="Search "
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={finalReport}
                columns={headCells}
                loading={loading}
                // isServerSide={true}
                handleEdit={EditReportData}
                handleDelete={DeleteReportData}
              // handleApprove={ActiveCompanyData}
              // tableTotalCount={filter.fn(company)?.length || 0}
              // tableOutputEvent={tableOutputEvent}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Dialog
        open={openPaidTransaction}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            maxWidth: { xs: "90%", sm: "70%", md: "50%", lg: "40%", xl: "30%" },
          },
        }}
      >
        {openPaidTransaction ? (
          <>
            <PaidTransaction
              selectedData={selectedData}
              GetData={isPaid ? PaidFunction : ReceivedFunction}
              setOpenPaidTransaction={setOpenPaidTransaction}
              GetUserWalletDetails={() => { }}
              PaidUserName={selectedUserName || selectedData.userName}
              functionType={functionType}
              isViewPaidTransaction={isViewPaidTransaction}
              setDrawerWidth={() => { }}
              onSubmit={handleSubmit}
              formRef={formRef}
              setValue={setValue}
              value={value}
            />
            <Box
              display="flex"
              justifyContent="flex-end"
              mt={4}
              sx={{
                backgroundColor: "#F1F4F7",
                borderTopColor: "#EAECF0",
                padding: "16px",
              }}
            ></Box>
          </>
        ) : null}
      </Dialog>

      <ConfirmBox
        open={openConfirmBox}
        title={"Delete"}
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton={"Delete"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color={"error"}
      />
    </>
  );
};
export default PaymentPaidAndReceived;
